import "./PasswordStrengthBar.css";

import { ThemeProvider, createTheme } from "@mui/material/styles";
import { useEffect, useState } from "react";

import LinearProgress from "@mui/material/LinearProgress";
import zxcvbn from "zxcvbn";

const passwordStrengthInfo = [
  {
    value: 0,
    label: "Weak",
    color: "#FF0000",
    percentage: 20,
  },
  {
    value: 1,
    label: "Okay",
    color: "#FFA500",
    percentage: 40,
  },
  {
    value: 2,
    label: "Good",
    color: "#FFFF00",
    percentage: 60,
  },
  {
    value: 3,
    label: "Strong",
    color: "#329632",
    percentage: 80,
  },
  {
    value: 4,
    label: "Very Strong",
    color: "#006400",
    percentage: 100,
  },
]

function GetPasswordStrength(password, minLength) {
  const passwordConditions = [
    {
      test: password => password.length >= minLength,
      message: `Password must be at least ${minLength} characters long`,
    },
    {
      test: password => /[a-z]/.test(password),
      message: "Password must contain at least 1 lowercase letter",
    },
    {
      test: password => /[A-Z]/.test(password),
      message: "Password must contain at least 1 uppercase letter",
    },
    {
      test: password => /\d/.test(password),
      message: "Password must contain at least 1 number",
    },
    {
      test: password => /[!@#$%^&*()\-+={}[\]:;"'<>,.?\/|\\~`]/.test(password),
      message: "Password must contain at least 1 special character (e.g., !@#)",
    },
  ];

  const failedCondition = passwordConditions.find(condition => !condition.test(password));

  if (failedCondition) {
    return {
      score: 0,
      message: failedCondition.message,
    }
  }

  const passwordStrengthScore = zxcvbn(password).score; // Returns a number between 0 and 4
  return {
    score: passwordStrengthScore,
    message: "",
  }
}


function PasswordStrengthBar(props) {
  const defaultStrengthInfo = passwordStrengthInfo.find(strengthInfo => strengthInfo.value === 0);

  const [passwordStrength, setPasswordStrength] = useState(defaultStrengthInfo.value);
  const [strengthMessage, setStrengthMessage] = useState(defaultStrengthInfo.label);
  const [strengthColor, setStrengthColor] = useState(defaultStrengthInfo.color);

  const theme = createTheme({
    palette: {
      primary: {
        main: strengthColor,
      },
    },
  });

  // On props.password change, calculate the strength of the password and set the progress bar
  useEffect(() => {
    const password = props.password;
    const minLength = props.minLength;

    const passwordResult = GetPasswordStrength(password, minLength);

    const dynamicPasswordStrengthInfo = passwordStrengthInfo.find(strengthInfo => strengthInfo.value === passwordResult.score);

    setPasswordStrength(dynamicPasswordStrengthInfo.percentage);
    setStrengthColor(dynamicPasswordStrengthInfo.color);

    if (passwordResult.message !== "") {
      setStrengthMessage(passwordResult.message);
    } else {
      setStrengthMessage(dynamicPasswordStrengthInfo.label);
    }
  }, [props.password]);

  return (
    <div className={props.className}>
      <ThemeProvider theme={theme}>
        <LinearProgress variant="determinate" value={passwordStrength} color="primary" style={{ backgroundColor: "#00000040" }} />
      </ThemeProvider>
      <p className="PasswordStrengthBar-message" style={{ color: strengthColor }}>{strengthMessage}</p>
    </div>
  );
}

export { PasswordStrengthBar, GetPasswordStrength };